import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import MarriageCertificateListingContent from './MarriageCertificateListingContent';
import useDebounce from '../../../../../../common/components/UseDebounce';
import CreateModal from '../components/CreateMarriageModal';
import UpdateModal from '../components/UpdateMarriageModal';
import MarriageImageContainer from '../components/MarriageImageContainer';

const form = {
  keyword: '',
};

function MarriageCertificateListingContainer({
  match,
  history,
  getMarriageCertificateList,
  marriageCertificateList,
  marriageCertificateListPager,
  isLoading,
  removeMarriageCertificate,
  showMarriageCertificate,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Marriage Certificate Record',
      modalSize: 'modal-xl',
    });
  };

  const handleViewImage = (data, page) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <MarriageImageContainer info={data} page={page} />,
      title: `Marriage Certificate - ${page}`,
      modalSize: 'modal-xl',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Record',
      modalSize: 'modal-xl',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this userManagement?',
      () => {
        removeMarriageCertificate(data.id, () => {
          getMarriageCertificateList();
          const id = _.get(marriageCertificateList, '0.id');
          history.push(`/marriage-certificate/${id}`);
          showMarriageCertificate(id);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  // const handleFilter = (e) => {
  //   e.preventDefault();
  //   getMarriageCertificateList({ ...formData });
  // };

  useEffect(() => {
    getMarriageCertificateList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getMarriageCertificateList({ q: formData.keyword, sort_by: 'asc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:marriageCertificateId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Records"
            getData={getMarriageCertificateList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search Records..."
            pathName={`${match.path}/:marriageCertificateId?`}
            listName="Transaction"
            label="Records List"
            renderItem={(item) => (
              <div className="px-3 py-3">
                {`${_.get(item, 'attributes.husband_first_name')} ${_.get(
                  item,
                  'attributes.husband_middle_name'
                ) || ''} ${_.get(item, 'attributes.husband_last_name')} & 
                ${_.get(item, 'attributes.wife_first_name')} ${_.get(
                  item,
                  'attributes.ife_middle_name'
                ) || ''} ${_.get(item, 'attributes.wife_last_name')}`}
              </div>
            )}
            isLoading={isLoading}
            selected={params.marriageCertificateId}
            data={marriageCertificateList}
            dataPager={marriageCertificateListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:marriageCertificateId?`}
                    render={() => (
                      <MarriageCertificateListingContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        handleViewImage={handleViewImage}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:marriageCertificateId?`}
                  render={() =>
                    !params.marriageCertificateId &&
                      marriageCertificateList.length > 0 ?
                      (
                        <Redirect
                          to={`${match.url}/${_.get(marriageCertificateList, '0.id')}`}
                        />
                      ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

MarriageCertificateListingContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getMarriageCertificateList: PropTypes.instanceOf(Function).isRequired,
  marriageCertificateList: PropTypes.instanceOf(Array).isRequired,
  marriageCertificateListPager: PropTypes.instanceOf(Object).isRequired,
  removeMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showMarriageCertificate: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  marriageCertificateList: _.get(api, `${c.GET_MARRIAGE_CERTIFICATE}.list`) || [],
  marriageCertificateListPager: _.get(api, `${c.GET_MARRIAGE_CERTIFICATE}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_MARRIAGE_CERTIFICATE) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(MarriageCertificateListingContainer);
